var map = {
	"./Badges.address.js": 330,
	"./ENS.address.js": 235,
	"./ERC20Vendable.address.js": 331,
	"./Emitter.address.js": 236,
	"./Exchange.address.js": 332,
	"./GnosisSafe.address.js": 333,
	"./Links.address.js": 334,
	"./LinksNFT.address.js": 335,
	"./ProxyFactory.address.js": 336,
	"./SafeBeacon.address.js": 337,
	"./StableCoin.address.js": 338,
	"./VendingMachine.address.js": 339
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 541;